export const themeColor = {
  primary: "#0d3f67",
  secondary: "#6b48ff",
  grey: "#f2f4f6",
  cyan: "#1ee3cf",
  white: "#fff",
  black: "#000000",
  whiteColor: "#fff",
  btnFadeColor: "#E8DAF9",
  baseColor: "green",
  captionColor: "#CACACA",
};
